// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 441) return "static/chunks/441-4f0fa1b565862f2c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"22":"e5c4b7107e3cc59e","54":"cdd56e5b15460fcf","346":"b4cccbe858864c2c","524":"14c03955b5a565df","668":"2b1cd69e364dadc6"}[chunkId] + ".js";
};